import { render, staticRenderFns } from "./Offering.vue?vue&type=template&id=833aae34&"
import script from "./Offering.vue?vue&type=script&lang=js&"
export * from "./Offering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports